(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tab-scroll"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var $url = document.querySelector('.as-category-tab-scroll-index-script');
    if (!window.categoryTabScroll && $url) {
      window.categoryTabScroll = $url.value;

      var $script = document.createElement('script');
      $script.src = window.categoryTabScroll;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
